class ModalAccessoriesCtrl {
    constructor() {}
}

export default ModalAccessoriesCtrl;